import { render } from "./DetailOrder.vue?vue&type=template&id=7b167342"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"

import "./DetailOrder.vue?vue&type=style&index=0&id=7b167342&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__